// extracted by mini-css-extract-plugin
module.exports = {"dots":"_636e9a9","dot":"_96ded46","active":"_262e9ab"};